import { useEffect, useState } from 'react';
import { Icon } from '../../../layout/Icon.jsx';
import { formatIQD } from '../../../shared/format.js';
import { usePosState } from '../hooks/usePosState.js';

export function DiscountModal({ open, onClose }) {
  const subtotalFn = usePosState((s) => s.subtotal);
  const invoiceDiscount = usePosState((s) => s.invoiceDiscount);
  const setInvoiceDiscount = usePosState((s) => s.setInvoiceDiscount);
  const subtotal = subtotalFn();

  const [value, setValue] = useState(invoiceDiscount);

  useEffect(() => {
    if (open) setValue(invoiceDiscount);
  }, [open, invoiceDiscount]);

  if (!open) return null;

  const v = Math.max(0, Math.min(subtotal, Math.floor(Number(value) || 0)));

  function apply() {
    setInvoiceDiscount(v);
    onClose?.();
  }

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center"
      style={{ background: 'rgba(0,0,0,.45)' }}
    >
      <div className="card w-[420px] max-w-[92vw] p-0" onClick={(e) => e.stopPropagation()}>
        <div className="card-h">
          <h3 className="flex-1 text-[15px] font-bold">خصم على الفاتورة</h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="card-b space-y-3">
          <div className="text-[12px] text-ink-3">المجموع الفرعي: <b>{formatIQD(subtotal)}</b></div>
          <label className="block text-xs font-semibold text-ink-2">قيمة الخصم (د.ع)</label>
          <input
            className="input"
            type="number"
            min={0}
            max={subtotal}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            autoFocus
          />
          <div className="flex justify-between text-[13px]">
            <span className="text-ink-2">الإجمالي بعد الخصم</span>
            <b className="text-orange-deep">{formatIQD(Math.max(0, subtotal - v))}</b>
          </div>
        </div>
        <div className="card-h border-t border-b-0 flex justify-end gap-2">
          <button type="button" className="btn" onClick={onClose}>إلغاء</button>
          <button type="button" className="btn btn-primary" onClick={apply}>تطبيق</button>
        </div>
      </div>
    </div>
  );
}
